/**
 * Created by - Ashlekh on 03-02-2025
 * Reason - To add Request callback form
 */

import React, { useState, useEffect } from "react";
import Style from "./RequestCallback.module.css";
import { RiCloseCircleLine } from "react-icons/ri";
import { requestCallbackAPI } from "../../Api/services";
import notificationObject from "../../components/Widgets/Notification/Notification";
import { FaPhoneAlt } from "react-icons/fa";

const RequestCallback = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [country, setCountry] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [errors, setErrors] = useState({});

  const handleRequestCallbackClick = () => {
    setIsVisible(true);
  };
  const validateEmail = (email) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  };
  const handleSubmit = async (e) => {
    const newErrors = {};

    if (!name.trim()) {
      newErrors.name = "Please enter name";
    }

    if (!phone.trim()) {
      newErrors.phone = "Please enter your mobile number";
    } else {
      const regex = /^[6-9]\d{9}$/;
      if (!regex.test(phone)) {
        newErrors.phone = "Invalid mobile number";
      }
    }
    if (!message.trim()) {
      newErrors.message = "Please write your query";
    }

    if (!validateEmail(email)) {
      newErrors.email = "Please enter a valid email address";
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    } else {
      setErrors({});
    }
    try {
      const formData = { name, email, country, phone, message, countryCode };
      const response = await requestCallbackAPI(formData);
      notificationObject.success(response.message);
      setIsVisible(false);
    } catch (error) {
      console.error("Error submitting callback request:", error);
    }
    setName("");
    setEmail("");
    setCountry("");
    setPhone("");
    setMessage("");
    setErrors({});
    setCountryCode("");
  };
  const handleClose = () => {
    setIsVisible(false);
    setName("");
    setEmail("");
    setCountry("");
    setPhone("");
    setMessage("");
    setErrors({});
    setCountryCode("+91");
  };
  return (
    <>
      <div className={Style.buttonContainer}>
        <button
          className={Style.requestCallbackButton}
          onClick={handleRequestCallbackClick}
        >
          <div className={Style.requestCallbackIconField}>
            <FaPhoneAlt className={Style.requestCallbackIcon} />
          </div>
          <div className={Style.requestCallbackText}>Request a Call Back</div>
        </button>
      </div>
      {isVisible && <div className={Style.overlay} />}
      {isVisible && (
        <div className={Style.mainContainer}>
          <div
            className={Style.model_container}
            style={{ display: isVisible ? "block" : "none" }}
          >
            <div className={Style.model_header}>
              <div className={Style.model_heading}>Inquiry</div>
              <div className={Style.close_button_field} onClick={handleClose}>
                <RiCloseCircleLine className={Style.close_button} />
              </div>
            </div>
            <div className={Style.model_contactContainer}>
              <div className={Style.name_email_field}>
                <div className={Style.name_container}>
                  <input
                    type="text"
                    name="name"
                    placeholder="Name *"
                    className={Style.inputBox}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                  {errors.name && (
                    <div className={Style.error_message}>{errors.name}</div>
                  )}
                </div>
                <div className={Style.email_container}>
                  <input
                    type="email"
                    name="email"
                    placeholder="Email *"
                    className={Style.inputBox}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {errors.email && (
                    <div className={Style.error_message}>{errors.email}</div>
                  )}
                </div>
              </div>

              <div className={Style.country_mobile_message_container}>
                <div className={Style.input_field}>
                  <div className={Style.country_container}>
                    <input
                      type="text"
                      name="country"
                      placeholder="Country"
                      className={Style.inputBox}
                      value={country}
                      onChange={(e) => setCountry(e.target.value)}
                    />
                  </div>
                  <div className={Style.phone_container}>
                    <div className={Style.phone_number_and_country_code}>
                      <div className={Style.countryCodeContainer}>
                        <input
                          type="text"
                          name="countryCode"
                          className={Style.inputCountryCode}
                          value={countryCode}
                          onChange={(e) => setCountryCode(e.target.value)}
                          maxLength={5}
                          required
                        />
                      </div>
                      <div className={Style.phoneNumberContainer}>
                        <input
                          type="text"
                          name="phone"
                          placeholder="Mobile Number *"
                          className={Style.phoneInputBox}
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                          required
                        />
                      </div>
                      {/* {errors.phone && (
                        <div className={Style.error_message}>
                          {errors.phone}
                        </div>
                      )} */}
                    </div>
                  </div>
                  {errors.phone && (
                    <div className={Style.error_message}>
                        {errors.phone}
                    </div>
                    )}
                  <div className={Style.message_container}>
                    <textarea
                      name="message"
                      placeholder="Message *"
                      className={Style.message_box}
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    />
                    {errors.message && (
                      <div className={Style.error_message}>
                        {errors.message}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className={Style.submit_field}>
                <button
                  type="button"
                  className={Style.submit_button}
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RequestCallback;
